import React, { useEffect, useState } from "react";
import { apiGet } from "../../utils/api";

const Project = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    async function exibir() {
      const payload = apiGet("/project");
      setProjects((await payload).data.data);
    }
    exibir();
  }, []);

  const onChangeHandler = async (e) => {
    // e.target.value ---> pega o conteudo da caixa de texto que gerou o evento onChangeHandler
    const payload = apiGet("/project/api/pesquisar?termo=" + e.target.value);

    setProjects((await payload).data.data);
  };

  /*
  const words = [
    { text: "Educação", value: 64 },
    { text: "EPT", value: 20 },
    { text: "IFSul", value: 30 },
    { text: "Pesquisa", value: 30 },
    { text: "Ensino médio", value: 60 },
    { text: "Extensão", value: 25 },
    { text: "Reforma", value: 40 },
    { text: "políticas", value: 30 },
    { text: "estudo ", value: 30 },
    { text: "tecnologia", value: 30 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
    { text: "ept", value: 50 },
  ];

  const options = {
    rotations: 2,
    rotationAngles: [-90, 0],
  };
  */

  return (
    <div>
      <section id="grupos" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Projetos de Pesquisa</h2>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <div className="search">
              <input
                type="text"
                onChange={(e) => onChangeHandler(e)}
                placeholder="Pesquisar projetos..."
              />
            </div>
          </div>
        </div>

        <br />

        {projects && projects.length ? (
          projects.map((project) => {
            return (
              <div className="row mx-5 posts" key={project.project_id}>
                <div className="card mb-3">
                  <div className="row">
                    <div className="card-body">
                      <article>
                        <h5 className="card-title">{project.title}</h5>
                        <div>
                          <p>{project.description}</p>
                        </div>
                        <div>
                          <b>Integrantes: </b> {project.members}
                        </div>
                        <div>
                          <b>Financiador(es): </b> {project.financiers}
                        </div>
                        <div className="projeto-separador"></div>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <>"Nenhum projeto registrado!"</>
        )}
      </section>
    </div>
  );
};

export default Project;
